
import { FunctionArgumentType, FunctionPlugin } from './FunctionPlugin';
export class IsEvenPlugin extends FunctionPlugin {
    iseven(ast, state) {
        return this.runFunction(ast.args, state, this.metadata('ISEVEN'), (val) => (val % 2 === 0));
    }
}
IsEvenPlugin.implementedFunctions = {
    'ISEVEN': {
        method: 'iseven',
        parameters: [
            { argumentType: FunctionArgumentType.NUMBER }
        ]
    },
};
